import apiService from '@/api/apiService';

export const assignPermissionsToRole = async (roleId, permissions) => {
    const url = `/api/admin/roles/${roleId}/permissions`;
    const data = {
        permissions: permissions
    };

    return apiService.POST(url, data);
};
